import './PaginatedList.scss';
import classNames from 'classnames';
import { GenericList } from './GenericList';
import { KeyPagination } from '@ui/KeyPagination';
import React, { useRef } from 'react';
const defaultListClassName = 'paginated-list';
const defaultPaginatorClassName = 'list-paginator';
export function PaginatedList({ empty, listClassName, loading, onChange, queryParams, paginatorClassName, renderListItem, resource }) {
    var _a, _b;
    const scrollableListRef = useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement(GenericList, { className: classNames(defaultListClassName, listClassName), empty: empty, items: (_a = resource === null || resource === void 0 ? void 0 : resource.results) !== null && _a !== void 0 ? _a : [], loading: loading, ref: scrollableListRef, renderItem: renderListItem }),
        React.createElement(KeyPagination, { autoHide: true, className: classNames(defaultPaginatorClassName, paginatorClassName), defaultPageSize: (_b = queryParams.count) !== null && _b !== void 0 ? _b : 20, listRef: scrollableListRef, onChange: onChange, resource: resource })));
}
